<div class="box-container" (click)="onTriangleClick($event)">
  <div class="triangle" [class.green]="rivi.r === 'ok'" [class.gray]="rivi.r === 'not-ok'" [class.orange]="rivi.r === 'partial-ok'"></div>
</div>
